import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Hero } from "@/components/home/Hero";
import { ServicesGrid } from "@/components/home/ServicesGrid";
import { InspectionBanner, WhyChoose, HowItWorks, PartnerCTA, SectionHead } from "@/components/home/HomeSections";
import { Reviews } from "@/components/home/Reviews";
import { CityList } from "@/components/home/CityList";
import { TrustStats } from "@/components/home/TrustStats";
import {
  BannerCarousel, FeaturedServices, EmergencySameDay, BeforeAfter, HowWeVerify, TrustBadges, ServiceGuarantee, VsOthers, HomeFaq, LatestBlogs,
} from "@/components/home/MoreSections";
import { useServices } from "@/lib/queries";
import { useSEO } from "@/lib/seo";
import { Skeleton } from "@/components/ui/skeleton";

export default function Home() {
  useSEO({ description: "Book trusted, verified professionals for AC, appliance, laptop & mobile repair, electrician, plumber, cleaning, bike and car services across India. ₹199 inspection.", path: "/" });
  const { data: services = [], isLoading } = useServices();
  return (
    <>
      <Hero />
      <TrustBadges />
      <BannerCarousel />
      {services.length > 0 && <FeaturedServices services={services} />}
      <section className="container-x pb-16" id="services" data-testid="home-services-section">
        <SectionHead
          eyebrow="Popular Services"
          title="Everything your home needs"
          sub="From appliance repairs to deep cleaning — booked in under a minute."
          action={<Link to="/services" className="text-sm font-semibold text-primary inline-flex items-center gap-1" data-testid="view-all-services-link">View all services <ArrowRight className="h-4 w-4" /></Link>}
        />
        {isLoading ? (
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">{[...Array(10)].map((_, i) => <Skeleton key={i} className="h-40 rounded-2xl" />)}</div>
        ) : (
          <ServicesGrid services={services} />
        )}
      </section>
      <InspectionBanner />
      <TrustStats />
      <EmergencySameDay />
      <BeforeAfter />
      <HowWeVerify />
      <WhyChoose />
      <HowItWorks />
      <ServiceGuarantee />
      <VsOthers />
      <Reviews />
      <PartnerCTA />
      <HomeFaq />
      <LatestBlogs />
      <section className="container-x pb-8" data-testid="cities-section">
        <SectionHead eyebrow="Cities We Serve" title="Serving customers across India's major cities" action={<Link to="/cities" className="text-sm font-semibold text-primary" data-testid="view-all-cities-link">All cities →</Link>} />
        <CityList limit={30} />
      </section>
    </>
  );
}
